import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestRoutes } from '../_config/rest-routes.config';
import { StateMaster } from '../_models/state-master.model';
import { CountStates } from '../_models/count-states.model';
import { environment } from 'src/environments/environment';
import { ElementLinkedStates } from '../_models/elementLinkedStates.model';






@Injectable({
  providedIn: 'root'
})
export class StateMasterService {

  httpOptions = {
    headers: new HttpHeaders(
      {
        'Content-type': 'application/json'
      }
    )
  };

  constructor(private http: HttpClient) { }


  Get(): Observable<StateMaster[]> {
    let urlCommerces: string = `${environment.urlWS}${RestRoutes.STATEMASTER_GET}`;
    return this.http.get<StateMaster[]>(urlCommerces, this.httpOptions);
  }

  GetState(): Observable<CountStates[]> {
    let urlCommerces: string = `${environment.urlWS}${RestRoutes.STATEMASTER_GETSTATES}`;
    return this.http.get<CountStates[]>(urlCommerces, this.httpOptions);
  }

  GetCountStates(): Observable<CountStates[]> {
    let urlCommerces: string = `${environment.urlWS}${RestRoutes.CLAIMOPERATIONS_STATESCOUNT}`;
    return this.http.get<CountStates[]>(urlCommerces, this.httpOptions);
  }
  GetLinkedElementStates(stateId: string): Observable<ElementLinkedStates[]> {
    let urlCommerces: string = `${environment.urlWS}${RestRoutes.STATE_GET_ELEMENTLINKEDSTATES.replace('{ID}', stateId)}`;
    return this.http.get<ElementLinkedStates[]>(urlCommerces, this.httpOptions);
  }


}
